import { useContext } from 'react'

import { NotyContext } from 'shared/components/Noty'

/**
 * @typedef {import('../components/Noty/hooks/useNotyCore').TNotyContext} TNotyContext
 */

/**
 * Custom hook to retrieve all noty actions from the global NotyProvider
 * @return {TNotyContext}
 */
export const useNoty = () => {
  return useContext(NotyContext) || {}
}
